/** @generated */
// cspell:disable

/** @typedef {import('axios').AxiosInstance} AxiosInstance */

import { SweetPath } from 'sweet-path';

/**
 * @typedef {import('./comment-update-action-body').CommentUpdateActionBody} CommentUpdateActionBody
 */

/**
 * @typedef {import('./comment-update-action-response').CommentUpdateActionResponse} CommentUpdateActionResponse
 */

/**
 * The path of the CommentUpdateAction action.
 */
export const commentUpdateActionPath = new SweetPath('/api/comment/comment/{comment_thread_id}/{comment_id}', {
  path: '{param}',
});

/**
 * Creates a contextualized CommentUpdateAction action.
 *
 * @param {AxiosInstance} axios
 */
export default function createCommentUpdateAction(axios) {
  /**
   * The commentUpdateAction action.
   *
   * @param { { headers: Object<string,string>,parameters: Object<string,string|number|boolean>,body: CommentUpdateActionBody } }
   *
   * @returns {Promise<CommentUpdateActionResponse>}
   */
  function commentUpdateAction({ headers = {}, parameters = {}, body } = {}) {
    const path = commentUpdateActionPath.insert(parameters);

    return axios.put(path, body, { headers });
  }

  return commentUpdateAction;
}
